/**
 * Потолок бесплатных уроков: не больше 3 и хотя бы один урок остаётся платным.
 * Точное зеркало формулы api `max(0, min(3, уроков − 1))`.
 */
export const trialLessonsLimit = (lessons: number): number => Math.max(0, Math.min(3, lessons - 1))
